module.exports = __webpack_public_path__ + "img/empty_sensor.81fb022c.svg";